import { useState } from 'react';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);

  const handleNewsletterSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const submitData = new URLSearchParams();
      submitData.append('email', email);
      submitData.append('tipo', 'newsletter');

      const response = await fetch('https://readdy.ai/api/form/d473r8d34biqimnfocd0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: submitData.toString()
      });

      if (response.ok) {
        setShowSuccess(true);
        setEmail('');
        setTimeout(() => setShowSuccess(false), 3000);
      }
    } catch (error) {
      console.error('Error al suscribirse:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const openWhatsApp = () => {
    window.open('https://wa.me/5491155857757?text=Hola! Me interesa conocer más sobre sus productos de Perra Luxury', '_blank');
  };

  const openInstagram = () => {
    window.open('https://instagram.com/pabloroma.ok', '_blank');
  };

  return (
    <footer id="contacto" className="bg-black text-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo and Description */}
          <div className="md:col-span-2">
            <h3 
              className="text-3xl font-thin text-[#C6A45C] mb-4"
              style={{ fontFamily: '"Lato", sans-serif' }}
            >
              Perra Luxury
            </h3>
            <p className="text-gray-300 mb-6 max-w-md font-thin" style={{ fontFamily: '"Lato", sans-serif' }}>
              Carteras y accesorios de lujo hechos a mano en Buenos Aires. 
              Cada pieza refleja la elegancia y el poder de la mujer moderna.
            </p>
            
            {/* Social Media */}
            <div className="flex space-x-4">
              <a 
                href="https://instagram.com/perraluxury" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-[#C6A45C] rounded-full flex items-center justify-center hover:bg-[#B8954F] transition-colors duration-300"
              >
                <i className="ri-instagram-line text-white"></i>
              </a>
              <a 
                href="https://wa.me/5491155857757?text=Hola! Me interesa conocer más sobre sus productos de Perra Luxury" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-[#25D366] rounded-full flex items-center justify-center hover:bg-[#20BA5A] transition-colors duration-300"
              >
                <i className="ri-whatsapp-line text-white"></i>
              </a>
            </div>
          </div>

          {/* Quick Menu */}
          <div>
            <h4 className="text-lg font-thin text-[#C6A45C] mb-4" style={{ fontFamily: '"Lato", sans-serif' }}>
              Menú Rápido
            </h4>
            <ul className="space-y-2">
              <li>
                <a href="#carteras" className="text-gray-300 hover:text-[#C6A45C] transition-colors duration-300 font-thin" style={{ fontFamily: '"Lato", sans-serif' }}>
                  Carteras
                </a>
              </li>
              <li>
                <a href="#accesorios" className="text-gray-300 hover:text-[#C6A45C] transition-colors duration-300 font-thin" style={{ fontFamily: '"Lato", sans-serif' }}>
                  Accesorios
                </a>
              </li>
              <li>
                <a href="#sobre-nosotros" className="text-gray-300 hover:text-[#C6A45C] transition-colors duration-300 font-thin" style={{ fontFamily: '"Lato", sans-serif' }}>
                  Sobre Nosotros
                </a>
              </li>
            </ul>
          </div>

          {/* Newsletter */}
          <div>
            <h4 className="text-lg font-thin text-[#C6A45C] mb-4" style={{ fontFamily: '"Lato", sans-serif' }}>
              Newsletter
            </h4>
            <p className="text-gray-300 text-sm mb-4 font-thin" style={{ fontFamily: '"Lato", sans-serif' }}>
              Suscríbete para recibir noticias sobre nuevas colecciones y ofertas exclusivas.
            </p>
            
            <form onSubmit={handleNewsletterSubmit} data-readdy-form>
              <div className="flex">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Tu email"
                  required
                  className="flex-1 px-4 py-2 bg-gray-800 text-white border border-gray-600 rounded-l-lg focus:outline-none focus:border-[#C6A45C] text-sm font-thin"
                  style={{ fontFamily: '"Lato", sans-serif' }}
                />
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="bg-[#C6A45C] text-white px-4 py-2 rounded-r-lg hover:bg-[#B8954F] transition-colors duration-300 disabled:opacity-50 whitespace-nowrap font-thin"
                  style={{ fontFamily: '"Lato", sans-serif' }}
                >
                  {isSubmitting ? '...' : 'Suscribir'}
                </button>
              </div>
            </form>
            
            {showSuccess && (
              <p className="text-green-400 text-sm mt-2 font-thin" style={{ fontFamily: '"Lato", sans-serif' }}>¡Suscripción exitosa!</p>
            )}
          </div>
        </div>

        {/* Contact Info */}
        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div>
              <h4 className="text-lg font-thin text-[#C6A45C] mb-4" style={{ fontFamily: '"Lato", sans-serif' }}>
                Contacto
              </h4>
              <div className="space-y-2 text-gray-300 font-thin" style={{ fontFamily: '"Lato", sans-serif' }}>
                <div className="flex items-center">
                  <div 
                    className="w-10 h-10 bg-[#25D366] rounded-full flex items-center justify-center mr-3 cursor-pointer hover:bg-[#20BA5A] transition-colors duration-300"
                    onClick={openWhatsApp}
                  >
                    <i className="ri-whatsapp-fill text-lg text-white"></i>
                  </div>
                  <div>
                    <p>+54 9 11 5585 7757</p>
                    <p className="text-sm text-gray-400">Nos manejamos únicamente por WhatsApp</p>
                  </div>
                </div>
                <p className="flex items-center mt-4">
                  <i className="ri-map-pin-line text-[#C6A45C] mr-2"></i>
                  Puerto Madero, Buenos Aires, República Argentina
                </p>
              </div>
            </div>

            <div>
              <h4 className="text-lg font-thin text-[#C6A45C] mb-4" style={{ fontFamily: '"Lato", sans-serif' }}>
                Información de Envíos
              </h4>
              <div className="text-gray-300 text-sm space-y-2 font-thin" style={{ fontFamily: '"Lato", sans-serif' }}>
                <p>• Envíos por Uber Express</p>
                <p>• Costo del Uber a cargo del comprador</p>
                <p>• Link de seguimiento en tiempo real</p>
                <p>• Recomendación: estar disponible para recibir el pedido</p>
              </div>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-800 mt-8 pt-8">
          {/* Términos y Política */}
          <div className="flex justify-center space-x-6 mb-4">
            <button 
              onClick={() => setShowTerms(true)}
              className="text-[#C6A45C] hover:text-[#B8954F] text-sm transition-colors duration-300 font-thin underline"
              style={{ fontFamily: '"Lato", sans-serif' }}
            >
              Términos y Condiciones
            </button>
            <button 
              onClick={() => setShowPrivacy(true)}
              className="text-[#C6A45C] hover:text-[#B8954F] text-sm transition-colors duration-300 font-thin underline"
              style={{ fontFamily: '"Lato", sans-serif' }}
            >
              Política de Privacidad
            </button>
          </div>

          <div className="flex justify-between items-center">
            <p className="text-[#C6A45C] text-sm font-thin" style={{ fontFamily: '"Lato", sans-serif' }}>
              © 2025 Perra Luxury — Diseñado con amor en Buenos Aires
            </p>
            <button 
              onClick={openInstagram}
              className="text-[#C6A45C] hover:text-[#B8954F] text-sm transition-colors duration-300 font-thin"
              style={{ fontFamily: '"Lato", sans-serif' }}
            >
              Designed by Pablo Roma
            </button>
          </div>
          
          <div className="text-center mt-2">
            <a 
              href="https://readdy.ai/?origin=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-[#C6A45C] text-xs transition-colors duration-300 font-thin"
              style={{ fontFamily: '"Lato", sans-serif' }}
            >
              Website Builder
            </a>
          </div>
        </div>
      </div>

      {/* Pop-up Términos y Condiciones */}
      {showTerms && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
          <div className="absolute inset-0 bg-black/80 backdrop-blur-sm" onClick={() => setShowTerms(false)}></div>
          <div className="relative bg-black border border-[#C6A45C]/30 rounded-lg max-w-2xl w-full max-h-[80vh] overflow-hidden">
            <div className="sticky top-0 bg-black border-b border-[#C6A45C]/30 p-4 flex justify-between items-center">
              <h2 className="text-2xl font-thin text-[#C6A45C] uppercase tracking-wider" style={{ fontFamily: '"Lato", sans-serif' }}>
                Términos y Condiciones
              </h2>
              <button 
                onClick={() => setShowTerms(false)}
                className="text-[#C6A45C] hover:text-[#B8954F] transition-colors duration-300"
              >
                <i className="ri-close-line text-2xl"></i>
              </button>
            </div>
            <div className="p-6 overflow-y-auto max-h-[calc(80vh-80px)]">
              <div className="text-[#C6A45C] font-thin leading-relaxed space-y-4" style={{ fontFamily: '"Lato", sans-serif' }}>
                <h3 className="text-lg font-medium text-[#C6A45C] mb-3">1. ACEPTACIÓN DE TÉRMINOS</h3>
                <p>Al acceder y utilizar este sitio web, usted acepta estar sujeto a estos términos y condiciones de uso. Si no está de acuerdo con alguna parte de estos términos, no debe utilizar nuestro sitio web.</p>

                <h3 className="text-lg font-medium text-[#C6A45C] mb-3 mt-6">2. PRODUCTOS Y SERVICIOS</h3>
                <p>Perra Luxury ofrece carteras y accesorios de lujo hechos a mano. Todos nuestros productos son únicos y pueden presentar variaciones naturales en el acabado debido a su naturaleza artesanal.</p>

                <h3 className="text-lg font-medium text-[#C6A45C] mb-3 mt-6">3. PROCESO DE COMPRA</h3>
                <p>Las compras se realizan a través de WhatsApp. Los precios están expresados en pesos argentinos y pueden estar sujetos a cambios sin previo aviso. La confirmación del pedido se realizará por WhatsApp.</p>

                <h3 className="text-lg font-medium text-[#C6A45C] mb-3 mt-6">4. ENVÍOS</h3>
                <p>Los envíos se realizan por Uber Express. El costo del envío es a cargo del comprador. Proporcionamos link de seguimiento para monitorear el pedido en tiempo real.</p>

                <h3 className="text-lg font-medium text-[#C6A45C] mb-3 mt-6">5. POLÍTICA DE DEVOLUCIONES</h3>
                <p>Debido a la naturaleza artesanal de nuestros productos, las devoluciones se evalúan caso por caso. Contacte por WhatsApp para consultas sobre devoluciones.</p>

                <h3 className="text-lg font-medium text-[#C6A45C] mb-3 mt-6">6. PROPIEDAD INTELECTUAL</h3>
                <p>Todo el contenido de este sitio web, incluyendo diseños, textos, gráficos y fotografías, es propiedad de Perra Luxury y está protegido por las leyes de propiedad intelectual.</p>

                <h3 className="text-lg font-medium text-[#C6A45C] mb-3 mt-6">7. LIMITACIÓN DE RESPONSABILIDAD</h3>
                <p>Perra Luxury no será responsable por daños indirectos, incidentales o consecuentes que puedan surgir del uso de nuestros productos o servicios.</p>

                <h3 className="text-lg font-medium text-[#C6A45C] mb-3 mt-6">8. MODIFICACIONES</h3>
                <p>Nos reservamos el derecho de modificar estos términos en cualquier momento. Las modificaciones entrarán en vigor inmediatamente después de su publicación en el sitio web.</p>

                <h3 className="text-lg font-medium text-[#C6A45C] mb-3 mt-6">9. CONTACTO</h3>
                <p>Para cualquier consulta sobre estos términos, puede contactarnos por WhatsApp al +54 9 11 5585 7757.</p>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Pop-up Política de Privacidad */}
      {showPrivacy && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
          <div className="absolute inset-0 bg-black/80 backdrop-blur-sm" onClick={() => setShowPrivacy(false)}></div>
          <div className="relative bg-black border border-[#C6A45C]/30 rounded-lg max-w-2xl w-full max-h-[80vh] overflow-hidden">
            <div className="sticky top-0 bg-black border-b border-[#C6A45C]/30 p-4 flex justify-between items-center">
              <h2 className="text-2xl font-thin text-[#C6A45C] uppercase tracking-wider" style={{ fontFamily: '"Lato", sans-serif' }}>
                Política de Privacidad
              </h2>
              <button 
                onClick={() => setShowPrivacy(false)}
                className="text-[#C6A45C] hover:text-[#B8954F] transition-colors duration-300"
              >
                <i className="ri-close-line text-2xl"></i>
              </button>
            </div>
            <div className="p-6 overflow-y-auto max-h-[calc(80vh-80px)]">
              <div className="text-[#C6A45C] font-thin leading-relaxed space-y-4" style={{ fontFamily: '"Lato", sans-serif' }}>
                <h3 className="text-lg font-medium text-[#C6A45C] mb-3">1. INFORMACIÓN QUE RECOPILAMOS</h3>
                <p>Recopilamos información personal que usted nos proporciona voluntariamente, incluyendo nombre, dirección de correo electrónico, número de teléfono y dirección de envío cuando realiza un pedido.</p>

                <h3 className="text-lg font-medium text-[#C6A45C] mb-3 mt-6">2. CÓMO UTILIZAMOS SU INFORMACIÓN</h3>
                <p>Utilizamos su información personal para procesar pedidos, comunicarnos con usted sobre su compra, enviar actualizaciones sobre productos y mejorar nuestros servicios.</p>

                <h3 className="text-lg font-medium text-[#C6A45C] mb-3 mt-6">3. COMPARTIR INFORMACIÓN</h3>
                <p>No vendemos, intercambiamos ni transferimos su información personal a terceros, excepto cuando sea necesario para completar su pedido (como servicios de envío).</p>

                <h3 className="text-lg font-medium text-[#C6A45C] mb-3 mt-6">4. SEGURIDAD DE DATOS</h3>
                <p>Implementamos medidas de seguridad apropiadas para proteger su información personal contra acceso no autorizado, alteración, divulgación o destrucción.</p>

                <h3 className="text-lg font-medium text-[#C6A45C] mb-3 mt-6">5. COOKIES</h3>
                <p>Nuestro sitio web puede utilizar cookies para mejorar su experiencia de navegación. Puede configurar su navegador para rechazar cookies, aunque esto puede afectar la funcionalidad del sitio.</p>

                <h3 className="text-lg font-medium text-[#C6A45C] mb-3 mt-6">6. NEWSLETTER</h3>
                <p>Si se suscribe a nuestro newsletter, utilizaremos su dirección de correo electrónico para enviarle actualizaciones sobre productos y ofertas. Puede darse de baja en cualquier momento.</p>

                <h3 className="text-lg font-medium text-[#C6A45C] mb-3 mt-6">7. DERECHOS DEL USUARIO</h3>
                <p>Usted tiene derecho a acceder, corregir o eliminar su información personal. Para ejercer estos derechos, contáctenos por WhatsApp.</p>

                <h3 className="text-lg font-medium text-[#C6A45C] mb-3 mt-6">8. MENORES DE EDAD</h3>
                <p>Nuestros servicios no están dirigidos a menores de 18 años. No recopilamos conscientemente información personal de menores de edad.</p>

                <h3 className="text-lg font-medium text-[#C6A45C] mb-3 mt-6">9. CAMBIOS EN LA POLÍTICA</h3>
                <p>Podemos actualizar esta política de privacidad ocasionalmente. Le notificaremos sobre cambios significativos publicando la nueva política en nuestro sitio web.</p>

                <h3 className="text-lg font-medium text-[#C6A45C] mb-3 mt-6">10. CONTACTO</h3>
                <p>Si tiene preguntas sobre esta política de privacidad, puede contactarnos por WhatsApp al +54 9 11 5585 7757.</p>
              </div>
            </div>
          </div>
        </div>
      )}
    </footer>
  );
}
